import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Controller2: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m630 630h-480v-480h405c41.35 0 75 33.64 75 75zm-450-30h420v-375c0-24.81-20.19-45-45-45h-375z' />
    <path d='m240 750v-90s30 0 30 0v60c0 16.57-13.43 30-30 30z' />
    <path d='m510 750v-90s30 0 30 0v60c0 16.57-13.43 30-30 30z' />
    <path d='m480 413.49-95.66 94.8c-9.03 8.95-24.37 2.55-24.37-10.16v-75.7h-59.07c-14.06 0-21.08-17.02-11.11-26.93l134.17-123.51c9.63-9.57 26.01-2.75 26.01 10.81v79.63h-30v-45l-84.93 75h54.93v70l47.6-48.69c11.65-11.78 30.64-11.9 42.43-.26z' />
  </IconBase>
));

Controller2.displayName = 'Controller2';

export default Controller2;
